import React, { Component } from "react";
import styles from "./controlList.module.scss";

import { NavLink } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { withAuth } from "../../../shared/containers/containerAuth";

const controlsItems = [
  {
    title: "Пользователи",
    url: "/controls/users",
    permissions: 20004,
  },
  {
    title: "Группы ТС",
    url: "/controls/groups",
    permissions: null,
  },
  {
    title: "Водители",
    url: "/controls/drivers",
    permissions: 62001,
  },
  {
    title: "Конструктор отчетов",
    url: "/controls/reportConstructor",
    permissions: null,
  },
  {
    title: "Зимнее содержание",
    url: "/winter/units",
    permissions: 38001,
  },
];

class ControlList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: window.location.pathname,
    };
  }

  render() {
    const { data } = this.props;

    return controlsItems.map((item) => {
      const { pathname } = this.state;

      if (item.permissions !== null && !data.permissions.includes(item.permissions)) {
        return null;
      }

      return (
        <NavLink key={uuidv4()} to={item.url}>
          <div
            className={styles.controlItemContainer}
            onClick={() => {
              this.setState({ pathname: item.url });
            }}
          >
            <div className={pathname.includes(item.url) ? styles.controlItemSelect : styles.controlItem}>{item.title}</div>
          </div>
        </NavLink>
      );
    });
  }
}

export default withAuth(React.memo(ControlList));
